import { UserSessionDataForm } from "./login/user-session-data-form";
import { ProjectDataForm } from "./project-data-form";
import { SessionActivityDataForm } from "./session-activity-data-form";

export class PatentDraftDataForm {
    patentDraftBriefDescriptionId: number;
    patentDraftDetailedDescriptionId: number;
    inventionFields: String;
    technologyDevelopment: String;
    addressedProblem: String;
    relevantPatentDocumentStatus: string;
    relevantPatents: String;
    paperPublishedStatus: string;
    relevantNpl: String;
    priorArtDrawbacks: String;
    solution: String;
    inventionObjective: String;
    componentFunction: String;
    additionalFeatures: String;
    inventionOverview: String;
    componentDetails: String;
    workFlow: String;
    drawingDescription: String;
    advantages: String;
    claims: String;
    abstractDetails: String;
    projectId: number;
    projectDataForm: ProjectDataForm;
    userSessionDataForm: UserSessionDataForm;
    sessionActivityDataForm: SessionActivityDataForm;
}
